import { Calendar, Clock, CheckCircle2 } from 'lucide-react';

const formatDate = (value) => {
    if (!value) return 'Não disponível';
    return new Date(value).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
};

const formatDateTime = (value) => {
    if (!value) return 'Não disponível';
    return new Date(value).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export function AccountInfoCard({ user }) {
    return (
        <div className="card custom-card h-100">
            <div className="card-body p-4">
                <h3 className="h5 fw-semibold mb-4">Informações da Conta</h3>

                <div className="d-flex flex-column gap-4">
                    <div className="d-flex align-items-center gap-3">
                        <div className="icon-container">
                            <Calendar size={16} className="text-muted-custom" />
                        </div>
                        <div>
                            <p className="small text-muted-custom mb-1">Membro desde</p>
                            <p className="fw-semibold mb-0">{formatDate(user?.usuario_data_cadastro)}</p>
                        </div>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        <div className="icon-container">
                            <Clock size={16} className="text-muted-custom" />
                        </div>
                        <div>
                            <p className="small text-muted-custom mb-1">Último acesso</p>
                            <p className="fw-semibold mb-0">{formatDateTime(user?.usuario_ultimo_acesso)}</p>
                        </div>
                    </div>
                </div>

                <span className="badge-primary-custom d-inline-flex align-items-center gap-2 mt-4 px-3 py-2 rounded-pill">
                    <CheckCircle2 size={14} /> Conta ativa
                </span>
            </div>
        </div>
    );
}
